const keyMirror = require('keymirror');

const ORDER_BUSINESS_TYPES = keyMirror({
  B2C: null,
  B2B: null,
});

export default ORDER_BUSINESS_TYPES;
